import {
  getFormValue,
  getQuestion,
  setQuestionVisibility,
} from 'app/services/businessFunctionHelpers';
import { FieldsEnum, FormsEnum } from 'app/shared/enums';
import { historyQuestionsVisibilityBasedOnPersonalData } from 'app/services/env.service';
import { setupInsuranceHistoryVisibility } from 'app/services/businessFunctions/helpers/setupInsuranceHistoryVisibility';
import { setPersonalDataMessage } from 'app/services/businessFunctions/helpers/setPersonalDataMessage';
import { setMainOwnerSelectionQuestionVisibility } from 'app/services/businessFunctions/helpers/setMainOwnerSelectionQuestionVisibility';

interface PersonalDataMap {
  pesel: FieldsEnum;
  name: FieldsEnum;
  lastName: FieldsEnum;
  birthDate: FieldsEnum;
  familyName: FieldsEnum;
}

const setMoreOrLessPersonalData = (
  showMore: boolean,
  personalDataMap: PersonalDataMap,
  formName: FormsEnum
) => {
  const { pesel, name, lastName, birthDate, familyName } = personalDataMap;

  setQuestionVisibility({
    key: pesel,
    visible: showMore,
    formName,
  });
  setQuestionVisibility({
    key: name,
    visible: showMore,
    formName,
  });
  setQuestionVisibility({
    key: lastName,
    visible: showMore,
    formName,
  });

  if (
    [FieldsEnum.Coowners1BirthDate, FieldsEnum.Coowners2BirthDate].includes(
      birthDate
    )
  )
    setQuestionVisibility({
      key: birthDate,
      visible: !showMore,
      formName,
    });

  if (!showMore) {
    setQuestionVisibility({
      key: familyName,
      visible: false,
      formName,
    });
  }
};

const showMorePersonaData = {
  onShowMorePersonalDataChange(initialRun?: boolean) {
    const formName = FormsEnum.CalculationForm;
    const showMorePersonalData = getFormValue(FieldsEnum.PersonalDataPath);

    setMainOwnerSelectionQuestionVisibility();

    if (getQuestion(FieldsEnum.FillNameAndLastName)) {
      setQuestionVisibility({
        key: FieldsEnum.FillNameAndLastName,
        visible: showMorePersonalData,
        formName,
      });
    }

    const ownerMap = {
      pesel: FieldsEnum.OwnerPesel,
      name: FieldsEnum.OwnerName,
      lastName: FieldsEnum.OwnerLastName,
      birthDate: FieldsEnum.OwnerBirthDate,
      familyName: FieldsEnum.OwnerFamilyName,
    };

    setMoreOrLessPersonalData(showMorePersonalData, ownerMap, formName);

    const coowner1Map = {
      pesel: FieldsEnum.Coowners1Pesel,
      name: FieldsEnum.Coowners1Name,
      lastName: FieldsEnum.Coowners1LastName,
      birthDate: FieldsEnum.Coowners1BirthDate,
      familyName: FieldsEnum.Coowners1FamilyName,
    };

    setMoreOrLessPersonalData(showMorePersonalData, coowner1Map, formName);

    const coowner2Map = {
      pesel: FieldsEnum.Coowners2Pesel,
      name: FieldsEnum.Coowners2Name,
      lastName: FieldsEnum.Coowners2LastName,
      birthDate: FieldsEnum.Coowners2BirthDate,
      familyName: FieldsEnum.Coowners2FamilyName,
    };

    setMoreOrLessPersonalData(showMorePersonalData, coowner2Map, formName);

    if (historyQuestionsVisibilityBasedOnPersonalData) {
      setupInsuranceHistoryVisibility();
    }

    setPersonalDataMessage();
  },
};

export default showMorePersonaData;
